import React from "react";
import { Route } from "react-router-dom";
import OrganizationRoute from "./OrganizationRoute";

import EducationLayout from "apps/education-platform/layouts/EducationLayout";

import Dashboard from "apps/education-platform/pages/DashboardPage";
import Resources from "apps/education-platform/pages/ResourcesPage";
import Charts from "apps/education-platform/pages/ChartsPage";
import Exercises from "apps/education-platform/pages/ExercisesPage";
import Sheets from "apps/education-platform/pages/SheetsPage";
import PracticeStatistics from "apps/education-platform/pages/PracticeStatisticsPage";
import AnalysisTabs from "apps/education-platform/pages/AnalysisTabsPage";
import Files from "apps/education-platform/pages/files/FilesPage";

export default function EducationRoutes({ state }) {
  return (
    <>
      <Route element={<EducationLayout />}>
        {/* Globalna strona plików */}
        <Route
          path="/files/*"
          element={<Files />}
        />
        <Route element={<OrganizationRoute />}>
          <Route path="/:organization_symbol">
            <Route
              index
              element={<Dashboard state={state} />}
            />

            <Route
              path="dashboard"
              element={<Dashboard state={state} />}
            />

            {/* <Route
              path="files/*"
              element={<Files />}
            /> */}
          </Route>

          <Route path="/:organization_symbol/:organization_branch_symbol">
            <Route
              path="dashboard"
              element={<Dashboard state={state} />}
            />

            <Route
              path="resources"
              element={<Resources state={state} />}
            />

            <Route
              path="charts"
              element={<Charts state={state} />}
            />

            <Route
              path="exercises/:exercise_type"
              element={<Exercises state={state} />}
            />

            <Route
              path="sheets/:qualification_symbol/:qualification_id"
              element={<Sheets state={state} />}
            />

            <Route
              path="practicestats"
              element={<PracticeStatistics state={state} />}
            />

            <Route
              path="examanalysis"
              element={<AnalysisTabs state={state} />}
            />
          </Route>
        </Route>
      </Route>
    </>
  );
}